import { render, staticRenderFns } from "./CarouselControls.vue?vue&type=template&id=36bfc04f&scoped=true"
import script from "./CarouselControls.vue?vue&type=script&lang=js"
export * from "./CarouselControls.vue?vue&type=script&lang=js"
import style0 from "./CarouselControls.vue?vue&type=style&index=0&id=36bfc04f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bfc04f",
  null
  
)

export default component.exports